import { Box, Typography } from '@mui/material';
import React, { useMemo } from 'react';

import { ItemSourceEnum } from '../../../types/marketplace';
import { getItemSourceNote } from '../../../utils/itemSource';

import ReportItemSource from './ReportItemSource';

interface IProps {
  sources: ItemSourceEnum[];
  warehouseNames: string;
}

const ReportItemSourceDetails = ({ sources, warehouseNames }: IProps) => {
  const note = useMemo(() => getItemSourceNote(sources, warehouseNames), [sources, warehouseNames]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
      <ReportItemSource sources={sources} />
      {!!note && (
        <Typography variant="body2" color="text.secondary">
          {note}
        </Typography>
      )}
    </Box>
  );
};

export default ReportItemSourceDetails;
